import { Actions, createEffect } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { updateProduct } from './product_actions_creator';
import { ProductEffectsService } from './product_effects.service';
import { ofType } from '@ngrx/effects';
import { concatMap, map, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { IAppState } from '../../../app_state';

@Injectable()
export class ProductEffects {

  updateProduct = createEffect(() => this.action$.pipe(
    ofType(updateProduct),
    concatMap(action => of(action).pipe(withLatestFrom(this.store$))),
    map(([_, state]) => {
      let productState = state['app']['signup']['product'];
      this.productEffectService.updateProduct(productState);
    })),
    {
      dispatch: false
    });


  constructor(private action$: Actions,
              private store$: Store<IAppState>,
              private productEffectService: ProductEffectsService
  ) {
  }
}
